import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=874c33f4&scoped=true"
import script from "./curriculum.vue?vue&type=script&lang=js"
export * from "./curriculum.vue?vue&type=script&lang=js"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=874c33f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874c33f4",
  null
  
)

export default component.exports